<template>
    <div>
        <!-- <div
            class="text-red-700 text-sm mb-2 -mt-2 font-bold text-center"
            v-if="!validAddress"
        >
        {{__('All required fields must be completed')}}
        <Button
            @click="checkValid"
        >{{__('Check')}}</Button>

        </div> -->
        <div class="relative flex flex-col justify-center items-center">
            <div
                class="absolute inset-0 bg-gray-100 opacity-40"
                v-if="loading"
            ></div>
            <div id="paypal-button-container" class="w-full"
                :class="{
                    // ['opacity-80'] : !validAddress
                }"
            ></div>

            <Spinner
                v-if="loading"
                class="absolute h-10 w-10 text-gray-900 z-10"
            />
        </div>
    </div>
</template>
<script>

import Spinner from 'UI/Spinner';
import { inject, onMounted, ref, watch } from '@vue/runtime-core';
import { usePage } from '@inertiajs/inertia-vue3';
import Button from 'UI/Button';

import {
    getFirstName,
    getLastName
} from 'helper';

var paypalActions;
export default {
    props: ['total', 'active', 'pay'],
    components: {
        Spinner,
        Button
    },
    setup(props, { emit }) {

        const client = {
            sandbox: 'AUgo9q-_enGctvfVeXLgjoLCY8C-ScOjSyqx0IyQvIm5nuJFH8S4wNuUVArwg_hvbWIVtTIbXggZsC_G',
            production: 'AXZVDNimUVMHdnjC6eS40SQG9Q8EiRkb8Pfw5PIaRLW6aaP2ChD1p3mKnVEdyz3xWOKwyQJX5ezfCV5K'
        };

        // SANDBOX:
        // l: sb-trgvu7638539@personal.example.com
        // p: bT@j*^h7
        // sb-5xtee7636935@business.example.com
        // U_?o8SDv

        const form = inject('form');
        const validAddress = ref(false);
        const loading = ref(true);

        onMounted(() => {
            createScript();
        });

        watch(form.billing, (val, oldVal) => {
            let required = ['email', 'name', 'contact_name', 'address', 'phone', 'zip', 'city'];
            if(validAddress.value) {

                validAddress.value = false;
                // paypalActions.disable();
            }
        })

        function setLoaded() {
            paypal.Buttons({
                onInit: function(data, actions) {
                    // actions.disable();
                    paypalActions = actions;
                    loading.value = false;
                },
                createOrder: function(data, actions) {
                    if(!validAddress.value){
                        return false;
                    }

                    return actions.order.create({
                        intent: 'CAPTURE',
                        payer: {
                            name: {
                                given_name: getFirstName(form.billing.contact_name),
                                surname: getLastName(form.billing.contact_name)
                            },
                            email_address: form.billing.email,
                            phone: {
                                phone_number: {
                                    national_number: form.billing.phone,
                                }
                            }
                        },
                        purchase_units: [{
                            amount: {
                                value: props.total.toFixed(2),
                            }
                        }],
                        application_context: {
                            shipping_preference: 'NO_SHIPPING',
                            brand_name: usePage().props.value.appName,
                        },

                    });
                },
                onApprove: function(data, actions) {
                    return actions.order.capture().then(function(details) {
                        if(details.status == "COMPLETED") {
                            let transaction_id = details.purchase_units[0].payments.captures[0].id;
                            props.pay(transaction_id);
                        }
                        else alert( app.__('Whoops! Something went wrong.') );
                    });
                },
                onCancel: function (data, actions) {
                    alert( app.__('Transaction canceled') );
                    loading.value = false;
                },
                onError: function (err, actions) {
                    console.log( app.__('Error') );
                    loading.value = false;
                },
                onClick: function(e, actions)  {
                    emit('click-payment-button', e);
                    return checkValid(actions);
                },
                style: {
                    color:  'blue',
                    shape:  'rect',
                    label:  'pay',
                    height: 50,
                    size: 'responsive',
                }
            }).render('#paypal-button-container');
        };

        function checkValid(actions) {
            loading.value = true;

            return axios.post(route('checkout.check'), {
                billing: form.billing,
                type: 'billing'
            })
            .then((response) => {
                loading.value = false;

                if(response.status == 200 || response.statusText == "OK") {
                    validAddress.value = response.data.valid;

                    // props.pay(null, null);
                    return actions.resolve();
                } else {
                    return actions.reject();
                }
            })
            .catch((error) => {
                usePage().props.value.errors = error.response.data.errors;
                usePage().props.value.flash.error = error.response.data.message;

                validAddress.value = false;
                loading.value = false;

                return actions.reject();
            });
        }

        function createScript() {
            let payPalScript = document.createElement("script");

            let current = usePage().props.value.locale;
            let locale = {
                en: 'en_GB',
                pl: 'pl_PL',
                it: 'it_IT',
                fr: 'fr_FR',
                de: 'de_DE',
            };
            let currency = usePage().props.value.locale != 'pl' ? 'EUR' : 'EUR';

            const isDemoMode = window.location.href.includes('127.0.0.1') || window.location.href.includes('localhost') ? true : false;
            payPalScript
            .setAttribute(
                "src",
                "https://www.paypal.com/sdk/js?client-id=" + (process.env.NODE_ENV == 'development' && isDemoMode ? client.sandbox : client.production) + '&locale=' + locale[current] + "&currency=" + currency
                // + '&components=buttons,funding-eligibility'
            );

            document.body.appendChild(payPalScript);

            payPalScript.addEventListener('load', () => setLoaded())
        };

        return {
            createScript,
            setLoaded,
            checkValid,

            validAddress,
            loading,
        }
    },
}
</script>
<style scoped>
.absolute {
    z-index: 101 !important;
}
</style>
